export const CONSTANT_CURRENCY = "$";

export const CONSTANT_GENDER = [
  { key: 1, value: "Male" },
  { key: 0, value: "Female" },
  { key: 2, value: "Male or Female Both" },
];

export const getGender = (key) => {
  const gender = CONSTANT_GENDER.find((item) => item.key === key);
  return gender ? gender.value : "Unknown Gender";
};

export const CONSTANT_REDIRECT_TIME = 2000;

export const ORDERBY_FIELDS_LIST = [
  {
    name: "Name A-Z",
    value: "practices.practice_name ASC",
  },
  {
    name: "Name Z-A",
    value: "practices.practice_name DESC",
  },
  {
    name: "Reviews High",
    value: "reviews_avg_desc",
  },
  {
    name: "Reviews Low",
    value: "reviews_avg_asc",
  },
];

export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || null;

export const GOOGLE_MAP_LIBRARIES = ['places'];

// export const STIRPE_PUBLIC_KEY = "pk_test_51RE3TAReZGwV3aGwFvGEUB4JFJUtyUhZy6JAwKveXCHLsc2nsz1bKYrB3fNN1YBcR9T4KVMVITHP1IBXX2Fst8YK00mQbWnkIx"

export const STIRPE_PUBLIC_KEY = "pk_live_51RE3SnDa5xmqHv2sIYDAoSm5tbZqNGxaMl6U7rWPaoD7rcDhbsurY6nCixPm2llG9FdcfSkxJFkzBKcwikUSSwvo00qoCaOHf2"

export const BASEURL = "https://www.alliedhealth.com.au"